// The theme's JOIN WAITLIST button for sold-out sizes (main form and mobile sticky bar).
// It opens AMP Back in Stock's popup by clicking AMP's own #BIS_trigger, which stays in the
// page but hidden: AMP draws that button with background images, whose hover Safari can't animate.
if (!customElements.get('waitlist-button')) {
  customElements.define('waitlist-button', class extends HTMLElement {
    connectedCallback() {
      this.input = this.closest('form')?.querySelector('input[name="id"]');
      this.button = this.querySelector('button');
      this.onVariantChange = this.update.bind(this);
      this.onClick = this.open.bind(this);
      this.input?.addEventListener('change', this.onVariantChange);
      this.button?.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.input?.removeEventListener('change', this.onVariantChange);
      this.button?.removeEventListener('click', this.onClick);
    }

    // Sold-out sizes only; pre-order sizes stay available and use <preorder-waitlist>.
    update() {
      const json = this.closest('.product')?.querySelector('variant-radios script[type="application/json"]');
      const variant = json && JSON.parse(json.textContent).find((item) => String(item.id) === this.input.value);
      this.hidden = !variant || variant.available;
    }

    // AMP's popup is bound to #BIS_trigger, which it keeps on the selected size.
    open() {
      this.closest('.product')?.querySelector('#BIS_trigger')?.click();
    }
  });
}
